import { render, staticRenderFns } from "./VideosCard.vue?vue&type=template&id=a4338258&scoped=true&"
import script from "./VideosCard.vue?vue&type=script&lang=js&"
export * from "./VideosCard.vue?vue&type=script&lang=js&"
import style0 from "./VideosCard.vue?vue&type=style&index=0&id=a4338258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4338258",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
